module.exports = require('handlebars/runtime');


//////////////////
// WEBPACK FOOTER
// ./~/handlebars-template-loader/runtime/index.js
// module id = 427
// module chunks = 0